import _get from 'lodash/get';

export const selectThemeGroups = state => _get(state, 'website.themeListing.theme_group_views');

export const getWebsitePublished = state => _get(state, 'wedding.account.published', false);

export const getWeddingSlug = state => _get(state, 'wedding.wedding.slug');

export const getWeddingTheme = state => _get(state, 'wedding.theme', {});

export const getWeddingThemeKey = state => _get(state, 'wedding.theme.key');

export const getWeddingThemeGroupTitle = state => _get(state, 'wedding.themeGroupTitle');

export const getWeddingPreviewUrl = state => {
  const slug = getWeddingSlug(state);

  if (!slug) return '';

  return `/wedding/${slug}`;
};

export default {
  selectThemeGroups,
  getWebsitePublished,
  getWeddingSlug,
  getWeddingPreviewUrl,
  getWeddingTheme,
  getWeddingThemeKey,
  getWeddingThemeGroupTitle,
};



// WEBPACK FOOTER //
// ./src/selectors/website/websiteSelectors.js